import { Icon } from "@/components/icon/Icon";
import { Dialog } from "@/components/ui";
import { CONTRACT_SUMMARY, PROCESS_STEPS } from "@/data/process";

/** 견적 패널에서 열리는 진행 절차 안내. 문구는 data/process.ts 가 원본이에요. */

function ContractSummary() {
  return (
    <div className="mt-3 flex flex-col gap-3 rounded-md bg-background-alternative p-5">
      <div className="flex items-center gap-2">
        <Icon name="documentText" size={18} className="text-primary" />
        <span className="wds-label-1 font-semibold text-label-strong">계약서에 담기는 내용</span>
      </div>
      <dl className="flex flex-col gap-2">
        {CONTRACT_SUMMARY.map((term) => (
          <div key={term.label} className="flex flex-col gap-0.5 sm:flex-row sm:gap-3">
            <dt className="wds-caption-1 font-semibold text-label-strong sm:w-20 sm:shrink-0">{term.label}</dt>
            <dd className="wds-caption-1 leading-relaxed text-label-neutral">{term.body}</dd>
          </div>
        ))}
      </dl>
      <p className="wds-caption-1 text-label-assistive">
        실제 계약서는 프로젝트에 맞춰 조정되는 예시예요. 세부 조건은 계약 전에 함께 확정해요.
      </p>
    </div>
  );
}

export function QuoteProcessDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Dialog open={open} onClose={onClose} title="진행 절차와 계약 안내">
      <ol className="flex flex-col">
        {PROCESS_STEPS.map((step, index) => (
          <li key={step.title} className="relative flex gap-4 pb-8 last:pb-0">
            {/* 단계를 잇는 세로선 — 마지막 단계 아래로는 그리지 않아요. */}
            {index < PROCESS_STEPS.length - 1 && (
              <span aria-hidden="true" className="absolute top-9 bottom-0 left-4 w-px bg-line-alternative" />
            )}
            <span className="wds-label-1 z-10 flex size-8 shrink-0 items-center justify-center rounded-full bg-primary font-bold text-static-white tabular-nums">
              {index + 1}
            </span>
            <div className="flex flex-col gap-2 pt-1">
              <h3 className="wds-headline-2 text-label-strong">{step.title}</h3>
              <p className="wds-body-2-reading text-label-neutral">{step.body}</p>
              {step.showContract && <ContractSummary />}
            </div>
          </li>
        ))}
      </ol>
    </Dialog>
  );
}

export default QuoteProcessDialog;
